module.exports = __webpack_public_path__ + "img/inductrialInjuryPrevention_1.c83ff929.png";